export default {
  candidate: [],
  candidateLists: [],
  internalUsers: [],
  client: [],
  bookings: [],
  apiCallsInProgress: 0,
  clientLogin: [],
};
